import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import SignUpVerifyPage from './SignUpVerifyPage';

/**
 * Sign-up page route.
 */
const SignUpPageVerifyRoute: FuseRouteItemType = {
  path: 'sign-up-verify',
  element: <SignUpVerifyPage />,
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        },
        poweredBy: {
          fixed: true
        }
      }
    }
  },
  auth: authRoles.onlyGuest
};

export default SignUpPageVerifyRoute;
